import React, { useState } from "react"
import EmojiMartPicker from "@emoji-mart/react"
import googleEmojisData from "@emoji-mart/data/sets/15/google.json"
import ptBrI18n from "@emoji-mart/data/i18n/pt.json"
import { Popover, Grid, IconButton } from "@material-ui/core"
import { EmojiEmotionsOutlined as EmojiIcon } from "@material-ui/icons"

export type EmojiPickerProps = {
	onSelectEmoji: (emoji: string) => void
	disabled?: boolean
}

export type EmojiMartEmoji = {
	id: string
	name: string
	colons: string
	emoticons: string[]
	unified: string
	skin?: number
	native: string
}

export type EmojiMartSet = "google" | "apple" | "twitter" | "native" | "facebook"

const EmojiPicker: React.FC<EmojiPickerProps> = (props) => {
	const { onSelectEmoji, disabled } = props
	const [popoverAnchorElement, setPopoverAnchorElement] = useState<HTMLElement | null>(null)
	const [isPopoverOpen, setIsPopoverOpen] = useState(false)

	const handleEmojiPickerIconClick = (event: React.MouseEvent<HTMLElement>) => {
		setPopoverAnchorElement(event.currentTarget)
		setIsPopoverOpen(true)
	}

	const handleClose = () => {
		setPopoverAnchorElement(null)
		setIsPopoverOpen(false)
	}

	const handleEmojiSelect = (emoji: EmojiMartEmoji) => {
		if (emoji?.native) {
			onSelectEmoji(emoji.native)
		}
	}

	return (
		<>
			<Popover
				open={isPopoverOpen}
				anchorEl={popoverAnchorElement}
				onClose={handleClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
				transformOrigin={{ vertical: "top", horizontal: "center" }}
				keepMounted
				style={{ zIndex: 3000 }}
			>
				<Grid container>
					<EmojiMartPicker
						i18n={ptBrI18n}
						data={googleEmojisData}
						onEmojiSelect={handleEmojiSelect}
						locale="pt"
						previewPosition="none"
						searchPosition="top"
						set={"native" as EmojiMartSet}
						theme="light"
					/>
				</Grid>
			</Popover>
			<Grid onClick={handleEmojiPickerIconClick}>
				<IconButton disabled={disabled}>
					<EmojiIcon />
				</IconButton>
			</Grid>
		</>
	)
}

export default EmojiPicker
